export const AUTO_FETCH_TYPES = {
  CURRENT_PROJECT_ENTITLEMENTS: 'CURRENT_PROJECT_ENTITLEMENTS',
  CURRENT_ACCOUNTS_ENTITLEMENTS: 'CURRENT_ACCOUNTS_ENTITLEMENTS',
} as const;

export type AutoFetchTypes = typeof AUTO_FETCH_TYPES;
export type AutoFetchType = AutoFetchTypes[keyof AutoFetchTypes];

export const SERVICE_TYPES = {
  GNG: 'gng',
  COLLAB: 'collab',
  QUANTIFICATION: 'quantification',
  COST: 'cost',
  INSIGHT: 'insight',
  FNG: 'fng',
  ASSETS: 'assets',
  PROJECT_HOME: 'project_home',
  DOC_MANAGER: 'doc_manager',
  PROJECT_ADMIN: 'project_admin',
  ACCOUNT_ADMIN: 'account_admin',
  PM: 'pm',
} as const;

export const PRODUCT_IDS = {
  MODEL_COORDINATION: 'modelCoordination',
  DESIGN_COLLABORATION: 'designCollaboration',
  QUANTIFY: 'quantify',
  TAKEOFF: 'takeoff',
  COST: 'cost',
  INSIGHT: 'insight',
  BUILD: 'build',
  DOCS: 'docs',
  ACCOUNT_ADMINISTRATION: 'accountAdministration',
  /** CPA's key for the account administration product. */
  HUB_ADMINISTRATION: 'hubAdministration',
  PROJECT_ADMINISTRATION: 'projectAdministration',
  AUTOSPECS: 'autoSpecs',
  BUILDING_CONNECTED: 'buildingConnected',
  FORMA_DESIGN: 'forma',
  DATUM: 'datum',
} as const;

export const TOOL_IDS = {
  ACTIVITY: 'activity',
  APPS: 'apps',
  ASSETS: 'assets',
  BRIDGE: 'bridge',
  BUDGET: 'budget',
  CORRESPONDENCE: 'correspondence',
  COST: 'cost',
  COSTS: 'costs',
  COMPANIES: 'companies',
  CHANGE_ORDER: 'changeOrder',
  CHANGES: 'changes',
  CLASHES: 'clashes',
  CONFIGURATION: 'configuration',
  CONFIGURATION_MEMBERS: 'configurationMembers',
  CONTRACTS: 'contracts',
  DATA_CONNECTOR: 'dataConnector',
  DATA_TRANSITIONS: 'dataTransitions',
  DELIVERY_PLAN: 'deliveryPlan',
  DESIGN: 'design',
  DOCUMENTS: 'documents',
  ESTIMATE: 'estimate',
  FILES: 'files',
  FORMA_BOARD: 'formaBoard',
  FORECAST: 'forecast',
  WORKFLOWBUILDER: 'workflowBuilder',
  FORMS: 'forms',
  HANDOVER: 'handover',
  HOME: 'home',
  HUB_ACTIVITY: 'hubActivity',
  ISSUES: 'issues',
  INSIGHT_BUILDER: 'insightBuilder',
  LINKS: 'links',
  LIBRARY: 'library',
  MEETINGS: 'meetings',
  MEMBERS: 'members',
  MODEL_ANALYTICS: 'modelAnalytics',
  MODELS: 'models',
  NOTIFICATIONS: 'notifications',
  PERMISSIONS: 'permissions',
  PHOTOS: 'photos',
  PROJECTS: 'projects',
  PROJECT_CONTROLS: 'projectControls',
  PROJECT_MEMBERS: 'projectMembers',
  PROJECT_STATUS: 'projectStatus',
  QUALITY: 'quality',
  REPORTS: 'reports',
  REVIEWS: 'reviews',
  RFIS: 'rfis',
  BIDDING: 'bidding',
  RISK: 'risk',
  ROLES: 'roles',
  SAFETY: 'safety',
  SCHEDULE: 'schedule',
  SETTINGS: 'settings',
  SPECS: 'specs',
  SHEETS: 'sheets',
  SUBMITTALS: 'submittals',
  SUBSCRIPTIONS: 'subscriptions',
  TAKEOFF: 'takeoff',
  TEMPLATES: 'templates',
  TEMPLATE_MEMBERS: 'templateMembers',
  PACKAGES: 'packages',
  TEAM: 'team',
  TEMPLATE_NOTIFICATIONS: 'templateNotifications',
  TIMEKEEPING: 'timekeeping',
  TRANSMITTALS: 'transmittals',
  VIEWS: 'views',
  WORK_PLAN: 'workPlan',
  WORKFLOW_STUDIO: 'workflowStudio',
  CONTROLS_CENTER: 'controlsCenter',
  CLASSIFICATIONS: 'classifications',
  LOCATIONS: 'locations',
  CUSTOM_INTEGRATIONS: 'customIntegrations',
} as const;

export const ENTITLEMENTS_PLATFORM_TYPES = {
  ACC: 'acc',
  BIM360: 'bim360',
} as const;

export const PROJECT_CLASSIFICATION_TYPES = {
  PRODUCTION: 'production',
  SAMPLE: 'sample',
  TEMPLATE: 'template',
} as const;

export const USER_ID_TYPE = {
  ID: 'id',
  AUTODESK_ID: 'autodeskId',
};

export type USER_ID_TYPES = typeof USER_ID_TYPE;

export const ANALYTICS = {
  FORMAT_USER_ID_NOT_FOUND: 'prodex.format_user_display_name.id_not_found',
};
